import { render, staticRenderFns } from "./ChartVisitBars.vue?vue&type=template&id=3fa85277"
import script from "./ChartVisitBars.vue?vue&type=script&lang=ts"
export * from "./ChartVisitBars.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports